<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 292.36 61.48">
  <g id="Layer_2" data-name="Layer 2">
    <g id="Layer_1-2" data-name="Layer 1">
      <path class="cls-1" d="M268.12,13a24.24,24.24,0,1,0,24.24,24.24A24.26,24.26,0,0,0,268.12,13Zm0,35.59a11.35,11.35,0,1,1,11.35-11.35A11.36,11.36,0,0,1,268.12,48.59Z"/>
      <path class="cls-1" d="M158.93,13a24.24,24.24,0,1,0,24.23,24.24A24.26,24.26,0,0,0,158.93,13Zm0,35.59a11.35,11.35,0,1,1,11.34-11.35A11.36,11.36,0,0,1,158.93,48.59Z"/>
      <path class="cls-1" d="M24.24,13a24.07,24.07,0,0,0-11.18,2.74V0H0V36.14c0,.36,0,.73,0,1.1s0,.73,0,1.1v.17H0A24.24,24.24,0,1,0,24.24,13Zm0,35.65a11.41,11.41,0,1,1,11.4-11.41A11.41,11.41,0,0,1,24.22,48.65Z"/>
      <rect class="cls-1" x="58.58" y="14.43" width="13.63" height="45.62"/>
      <polygon class="cls-1" points="220.48 14.58 206.85 14.58 206.85 30.43 191.01 30.43 191.01 44.05 206.85 44.05 206.85 59.9 220.48 59.9 220.48 44.05 236.33 44.05 236.33 30.43 220.48 30.43 220.48 14.58"/>
      <polygon class="cls-1" points="118.17 14.39 104.66 27.9 91.15 14.39 81.52 24.02 95.03 37.53 81.52 51.04 91.15 60.68 104.66 47.17 118.17 60.68 127.81 51.04 114.3 37.53 127.81 24.02 118.17 14.39"/>
    </g>
  </g>
</svg>


<style lang="scss">
  svg {
    fill: var(--main);
    width: 100px;

    @media (min-width: 769px) {
      width: 130px;
    }
  }
</style>